import Button from "@components/atoms/Button";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../../../../hooks/useScreenOptionsHooks";

const ButtonContainer = ({
  onConfirm,
  isLoading,
  disabled,
  handleReviewChangesPopup,
  isModifyPlan,
}: {
  onConfirm: (type: "confirm_plan" | "modify_plan") => void;
  isLoading: boolean;
  disabled: boolean;
  handleReviewChangesPopup: () => void;
  isModifyPlan: boolean;
}) => {
  const { t } = useScreenOptionsHooks();
  return (
    <Overlay>
      <Button
        type={ButtonType.primary}
        title={
          isModifyPlan
            ? t("managePlan.popUp.button.reviewChanges.text", "Review Changes")
            : t("managePlan.popUp.button.primary.text", "Confirm Plan")
        }
        onPress={
          isModifyPlan
            ? handleReviewChangesPopup
            : () => onConfirm("confirm_plan")
        }
        category={ButtonCategory.default}
        loading={isLoading}
        disabled={disabled}
      />
    </Overlay>
  );
};

const Overlay = styled.View`
  width: 100%;
`;

export default ButtonContainer;
